<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg fill="currentColor" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M8.41,2.55,6,3.33,5.59,1A4.66,4.66,0,0,0,4.41,1L4,3.33,1.59,2.55A3.82,3.82,0,0,0,1,3.49L2.92,5,1,6.51a3.82,3.82,0,0,0,.59.94L4,6.67,4.41,9A4.66,4.66,0,0,0,5.59,9L6,6.67l2.37.78A3.69,3.69,0,0,0,9,6.51L7.08,5,9,3.49A3.82,3.82,0,0,0,8.41,2.55Z"
		></path>
	</svg>
</div>
